import React, { useContext } from "react";
import { arrayOf, bool, elementType, node, number, oneOf, shape, string } from "prop-types";
import AssetsProvider from "../utils/AssetsProvider";
import Link from "../Link";
import Image from "../Image";
import Block from "../Block";
import Icon from "../Icon";
import Picture, { sourceItemPropTypes } from "../Picture";
import { classes } from "../utils/classes";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { sizingClassName, sizingProps, sizingPropTypes } from "../props/sizing";

const CardBlock = ({
	LinkComponent = Link,
	className = "",
	imgClassName = "",
	imgSpacing = { ...spacingProps },
	imgWrapperUtility = { ...utilityProps },
	imgWrapperSizing = { ...sizingProps },
	imgWrapperSpacing = { ...spacingProps },
	imgWrapperClassName,
	imgSrc = "",
	imgSrcList = [],
	href,
	isImgFluid = false,
	titleText,
	descriptionText = "",
	cardType = "",
	linkButtonText,
	isBaseUrl = false,
	utility = { ...utilityProps },
	spacing = { ...spacingProps },
	linkMt = "auto",
	children = null,
}) => {
	const ctxBaseUrl = useContext(AssetsProvider.context);
	const baseUrl = isBaseUrl ? ctxBaseUrl : "";
	return (
		<div
			className={classes(
				"card-block",
				...utilityClassName(utility),
				...spacingClassName(spacing),
				className,
			)}
		>
			<LinkComponent href={href} isBaseClassName={false} className="card-block__title-link">
				{imgSrc && (
					<span
						className={classes(
							"card-block__image-section",
							isImgFluid && "card-block__image-section--fluid",
							...utilityClassName(imgWrapperUtility),
							...sizingClassName(imgWrapperSizing),
							...spacingClassName(imgWrapperSpacing),
							imgWrapperClassName,
						)}
					>
						{imgSrcList.length ? (
							<Picture
								src={imgSrc}
								srcList={imgSrcList}
								className={classes(
									"card-block__image",
									isImgFluid && "card-block__image--fluid",
									...spacingClassName(imgSpacing),
									imgClassName,
								)}
								isBaseUrl={false}
							/>
						) : null}
						{imgSrc && !imgSrcList.length ? (
							<Image
								src={`${baseUrl}${imgSrc}`}
								className={classes(
									"card-block__image",
									isImgFluid && "card-block__image--fluid",
									...spacingClassName(imgSpacing),
									imgClassName,
								)}
								isBaseUrl={false}
							/>
						) : null}
						{children}
					</span>
				)}
				<div className="card-block__link-section">
					{cardType && <span className="card-block__type">{cardType}</span>}
					<span className="card-block__title">{titleText}</span>
				</div>
			</LinkComponent>
			{(descriptionText || linkButtonText) && (
				<div className="card-block__content-section">
					<Block utility={{ display: "block" }} sx={{ fontColor: "black--64" }} spacing={{ mb: 2 }}>
						{descriptionText}
					</Block>
					<Block spacing={{ mt: linkMt }}>
						{linkButtonText && (
							<LinkComponent href={href} sx={{ fontSize: "m" }}>
								{linkButtonText} <Icon name="angle-right" />
							</LinkComponent>
						)}
					</Block>
				</div>
			)}
		</div>
	);
};

CardBlock.propTypes = {
	LinkComponent: elementType,
	className: string,
	imgSpacing: spacingPropTypes,
	imgClassName: string,
	imgWrapperClassName: string,
	imgWrapperUtility: utilityPropTypes,
	imgWrapperSizing: sizingPropTypes,
	imgWrapperSpacing: spacingPropTypes,
	imgSrc: string,
	imgSrcList: arrayOf(shape(sourceItemPropTypes)),
	isImgFluid: bool,
	cardType: string,
	href: string.isRequired,
	titleText: string.isRequired,
	descriptionText: string,
	linkButtonText: string,
	isBaseUrl: bool,
	utility: utilityPropTypes,
	spacing: spacingPropTypes,
	linkMt: oneOf([string, number]),
	children: node,
};
export default CardBlock;
